const VIDEO_URL_PATTERN = /\.(mp4|webm|mov|m4v|ogg|quicktime|avi)(\?|$)/i;

const hasVideoExtension = (value) =>
	typeof value === 'string' && VIDEO_URL_PATTERN.test(value);

export const inferStoryMediaType = (media, person = null, contentType = null) => {
	if (typeof contentType === 'string' && contentType.startsWith('video/')) {
		return 'video';
	}

	const profileVideoId =
		typeof person?.profile_video === 'string'
			? person.profile_video
			: person?.profile_video?._id?.toString?.() ??
				person?.profile_video?.toString?.();

	const mediaId =
		typeof media === 'string'
			? media
			: media?._id?.toString?.() ?? media?.id?.toString?.();

	if (profileVideoId && mediaId && profileVideoId === mediaId) {
		return 'video';
	}

	if (typeof media === 'object' && media) {
		const source = media.base64 || media.url || media.name || '';

		if (hasVideoExtension(source)) {
			return 'video';
		}
	}

	if (typeof media === 'string' && hasVideoExtension(media)) {
		return 'video';
	}

	return 'image';
};
